/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountCollectionUser
 */
export interface AccountCollectionUser {
    /**
     * 
     * @type {string}
     * @memberof AccountCollectionUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCollectionUser
     */
    handle: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountCollectionUser
     */
    isDeactivated?: boolean;
}

/**
 * Check if a given object implements the AccountCollectionUser interface.
 */
export function instanceOfAccountCollectionUser(value: object): value is AccountCollectionUser {
    let isInstance = true;
    isInstance = isInstance && "id" in value && value["id"] !== undefined;
    isInstance = isInstance && "handle" in value && value["handle"] !== undefined;

    return isInstance;
}

export function AccountCollectionUserFromJSON(json: any): AccountCollectionUser {
    return AccountCollectionUserFromJSONTyped(json, false);
}

export function AccountCollectionUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountCollectionUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'handle': json['handle'],
        'isDeactivated': !exists(json, 'is_deactivated') ? undefined : json['is_deactivated'],
    };
}

export function AccountCollectionUserToJSON(value?: AccountCollectionUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'handle': value.handle,
        'is_deactivated': value.isDeactivated,
    };
}

